import React from "react";

/**
 * Trailing debounce whose cancel() can be followed by further calls.
 * (throttle-debounce's cancel() permanently disables the function.)
 */
export function createDebouncer(delay, callback) {
  let timeoutId = null;

  const debounced = (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      timeoutId = null;
      callback(...args);
    }, delay);
  };

  debounced.cancel = () => {
    clearTimeout(timeoutId);
    timeoutId = null;
  };

  return debounced;
}

export function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

/**
 * Splits display text and wraps case-insensitive query matches in <strong>.
 */
export function highlightMatch(text, query) {
  if (!query || text == null || text === "") {
    return text;
  }

  const escaped = escapeRegExp(query);
  const parts = String(text)
    .split(new RegExp(`(${escaped})`, "gi"))
    .filter(part => part !== "");

  return parts.map((part, index) => {
    if (part.toLowerCase() === query.toLowerCase()) {
      return <strong key={index}>{part}</strong>;
    }
    return part;
  });
}
